import { type ElementType } from 'react';

import type { Locale } from 'date-fns';
import { de, enUS, es, fr, ja, ko, ru, tr } from 'date-fns/locale';

import { IconFlagDe, IconFlagRu, IconFlagUk } from '@/components/Icons';
import {
  IconFlagAz,
  IconFlagEs,
  IconFlagFr,
  IconFlagJp,
  IconFlagKr,
  IconFlagTr,
} from '@/components/Icons/icons-generated';
import type locales from '@/locales';

export type Language = {
  key: keyof typeof locales;
  dir?: 'ltr' | 'rtl';
  fontScale?: number;
  dataFnsLocale?: Locale;
  title: string;
  flag: ElementType;
};

export const DEFAULT_NAMESPACE = 'common';
export const USER_LANGUAGE_KEY = 'lang';

export const DEFAULT_LANGUAGE_KEY: Language['key'] = 'tr';

export const AVAILABLE_LANGUAGES: Array<Language> = [
  {
    key: 'tr',
    title: 'turkish',
    dataFnsLocale: tr,
    flag: IconFlagTr,
  },
  {
    key: 'en',
    dataFnsLocale: enUS,
    title: 'english',
    flag: IconFlagUk,
  },
  {
    key: 'de',
    dataFnsLocale: de,
    title: 'german',
    flag: IconFlagDe,
  },
  {
    key: 'ru',
    dataFnsLocale: ru,
    title: 'russian',
    flag: IconFlagRu,
  },
  {
    key: 'es',
    dataFnsLocale: es,
    title: 'spanish',
    flag: IconFlagEs,
  },
  {
    key: 'az',
    dataFnsLocale: tr,
    title: 'azerbaijani',
    flag: IconFlagAz,
  },
  {
    key: 'fr',
    dataFnsLocale: fr,
    title: 'french',
    flag: IconFlagFr,
  },
  {
    key: 'ja',
    dataFnsLocale: ja,
    title: 'japanese',
    flag: IconFlagJp,
  },
  {
    key: 'ko',
    dataFnsLocale: ko,
    title: 'korean',
    flag: IconFlagKr,
  },
] as const;

export type AvailableLanguageKeys = (typeof AVAILABLE_LANGUAGES)[number]['key'];

export const backendCultures = {
  en: 'en-US',
  tr: 'tr-TR',
  de: 'de-DE',
  ru: 'ru-RU',
  es: 'es-ES',
  az: 'az-AZ',
  fr: 'fr-FR',
  ja: 'ja-JP',
  ko: 'ko-KR',
} as const;

export type BackendCultures =
  (typeof backendCultures)[keyof typeof backendCultures];
